import LoadingWrapper, { LoadingWrapperProps } from "../loading-wrapper/LoadingWrapper";
import styles from "./PageLoader.module.scss";

const PageLoader = ({ size, isLoading }: LoadingWrapperProps) => (
  <LoadingWrapper className={styles.pageLoader} size={size} isLoading={isLoading} />
);

export default PageLoader;
